// Role-Based Access Control Configuration
// Defines what each role can access

export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  STAFF: 'staff',
  ACCOUNTANT: 'accountant',
};

// Module permissions by role
// true = full access, 'view' = read-only, false = no access
export const PERMISSIONS = {
  dashboard: {
    admin: true,
    manager: true,
    staff: true,
    accountant: true,
  },
  leads: {
    admin: true,
    manager: true,
    staff: true,
    accountant: false,
  },
  customers: {
    admin: true,
    manager: true,
    staff: true,
    accountant: false,
  },
  quotations: {
    admin: true,
    manager: true,
    staff: true,
    accountant: false,
  },
  bookings: {
    admin: true,
    manager: true,
    staff: true,
    accountant: 'view',
  },
  'booking-details': {
    admin: true,
    manager: true,
    staff: true,
    accountant: false,
  },
  itineraries: {
    admin: true,
    manager: true,
    staff: true,
    accountant: false,
  },
  visa: {
    admin: true,
    manager: true,
    staff: true,
    accountant: false,
  },
  payments: {
    admin: true,
    manager: true,
    staff: false,
    accountant: true,
  },
  whatsapp: {
    admin: true,
    manager: true,
    staff: true,
    accountant: false,
  },
  reports: {
    admin: true,
    manager: true,
    staff: false,
    accountant: true,
  },
  accounts: {
    admin: true,
    manager: 'view',
    staff: false,
    accountant: true,
  },
  users: {
    admin: true,
    manager: false,
    staff: false,
    accountant: false,
  },
  trips: {
    admin: true,
    manager: true,
    staff: true,
    accountant: false,
  },
  gallery: {
    admin: true,
    manager: true,
    staff: true,
    accountant: false,
  },
};

// Check if user has access to a module
export const hasAccess = (userRole, module) => {
  if (!userRole || !module) return false;
  const role = userRole.toLowerCase();
  const permission = PERMISSIONS[module]?.[role];
  return permission === true || permission === 'view';
};

// Check if user has full (write) access to a module
export const hasFullAccess = (userRole, module) => {
  if (!userRole || !module) return false;
  const role = userRole.toLowerCase();
  return PERMISSIONS[module]?.[role] === true;
};

// Check if user has view-only access
export const hasViewOnlyAccess = (userRole, module) => {
  if (!userRole || !module) return false;
  const role = userRole.toLowerCase();
  return PERMISSIONS[module]?.[role] === 'view';
};

// Get all accessible modules for a role
export const getAccessibleModules = (userRole) => {
  if (!userRole) return [];
  const role = userRole.toLowerCase();
  return Object.entries(PERMISSIONS)
    .filter(([_, perms]) => perms[role] === true || perms[role] === 'view')
    .map(([module]) => module);
};

// Navigation items with role-based filtering
export const getNavItemsForRole = (userRole, allNavItems) => {
  if (!userRole) return [];
  return allNavItems.filter((item) => {
    const module = item.module || item.path.replace('/', '');
    return hasAccess(userRole, module);
  });
};
